<template>
    <el-row type="flex" justify="center">
        <el-col :xs="{ span: 20 }" :sm="{ span: 20 }" :md="{ span: 16 }">
            <el-container class="card auto-width">
                <el-row>
                    <el-col>
                        <span class="title">{{ strings.title }}</span>
                    </el-col>
                  
                    <el-col :span="12" :offset="6">
                        <el-form ref="form" :model="form">
                            <el-row type="flex" justify="center">
                                <el-col>
                                    <el-form-item class="mb-0">
                                        <el-input v-model.trim="form.binNumber" autocomplete="off" autocorrect="off"
                                            autocapitalize="off" spellcheck="false" class="form-input full-width"
                                            autofocus type="number"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row class="mt-1">
                                <el-col :span="12" class="text-left">
                                    <router-link to="/action">
                                        <el-button type="default">
                                            {{ strings.form.backBtn }}
                                        </el-button>
                                    </router-link>
                                </el-col>
                                <el-col :span="12" class="text-right">
                                    <el-button type="info" class="form-button sm" :disabled="loading || !form.binNumber"
                                        @click.prevent="search()">
                                        <span v-if="!loading">{{ strings.form.submitBtn.label }}</span>
                                        <span v-if="loading">{{ strings.form.submitBtn.loading }}</span>
                                    </el-button>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-col>
                </el-row>
            </el-container>
        </el-col>
    </el-row>
</template>
  
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'SearchPage',
    data() {
        return {
            loading: false,
            form: {
                searchTerm: null
            },
            strings: {
                title: 'Bin Number',
                form: {
                    termInput: {
                        label: "Search by Phone or Driver's License",
                    },
                    backBtn: 'Back',
                    submitBtn: {
                        loading: 'Please wait...',
                        label: 'Next'
                    },
                },
                searchError: 'An error has occurred trying to search this swapper.'
            }
        };
    },
    computed: {
        ...mapGetters('shopper', ['searchError'])
    },
    methods: {
        async search() {
            const { binNumber } = this.form;

            // check if bin number is valid
            this.loading = true;

            let message = '';
            try {
                const response = await this.$store.dispatch('shopper/checkBin', binNumber);
                if (response.status === 200){
                    this.$store.dispatch('shopper/selectBinNumber', binNumber);
                    this.$router.push('/tags');
                }
            } catch (error) {
                if (error.response.status === 400){
                    message = error.response.data.error;
                } else {
                    message = this.strings.searchError;
                }
            } finally {
                this.loading = false;
            }

            if (message) {
                await this.$swal({
                    type: 'error',
                    title: 'Error',
                    text: message
                });
            }

        }
    }
};
</script>
  